import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Loader from '@Components/Loader';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
export var ProtectedRoute = function (_a) {
    var children = _a.children;
    var _b = useAuth(), session = _b.session, loading = _b.loading;
    if (loading)
        return _jsx(Loader, {}); // Or a loading UI
    return session ? _jsx(_Fragment, { children: children }) : _jsx(Navigate, { to: "/login" });
};
